import React from 'react'
import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SignupSubmitButton from './SignupSubmitButton'

interface EmailStepProps {
    email: string
    onEmailChange: (value: string) => void
    errorMessage?: string
    submitting: boolean
}

const EmailStep: React.FC<EmailStepProps> = ({ email, onEmailChange, errorMessage, submitting }) => {
    const { t } = useTranslation()

    return (
        <>
            <TextField
                fullWidth
                // eslint-disable-next-line jsx-a11y/no-autofocus -- first field of a fresh step
                autoFocus
                label={t('signup.email_label')}
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => onEmailChange(e.target.value)}
                error={!!errorMessage}
                helperText={errorMessage}
            />
            <SignupSubmitButton disabled={submitting || !email}>{t('signup.send_code_button')}</SignupSubmitButton>
        </>
    )
}

export default EmailStep
